"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CookieBannerTypes = void 0;
exports.cookieBannerSnippet = cookieBannerSnippet;
var CookieBannerTypes;
(function (CookieBannerTypes) {
    CookieBannerTypes["MAIN"] = "DE";
    CookieBannerTypes["AFFILIATES"] = "FR";
    CookieBannerTypes["MOBLE_DE"] = "AT";
})(CookieBannerTypes || (exports.CookieBannerTypes = CookieBannerTypes = {}));
function cookieBannerSnippet(type = CookieBannerTypes.MAIN) {
    return `window.OneTrust = { geolocationResponse: { countryCode: '${type}' } };`;
}
//# sourceMappingURL=cookie-banner.js.map